import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ConfigPanelTab {
  id: string;
  label: string;
  icon: string;
  disabled?: boolean;
  badge?: string;
}

@Component({
  selector: 'app-config-panel',
  templateUrl: './config-panel.component.html',
  styleUrls: ['./config-panel.css']
})
export class ConfigPanelComponent {

  @Input() title: string = 'Configuración';

  @Input() description: string = '';

  @Input() tabs: ConfigPanelTab[] = [];

  @Input() activeTab: string = '';

  @Output() activeTabChange = new EventEmitter<string>();

  ngOnInit(): void {
    if (!this.activeTab && this.tabs.length > 0) {
      this.activeTab = this.tabs[0].id;
    }
  }

  selectTab(tab: ConfigPanelTab): void {

    if (tab.disabled) {
      return;
    }

    this.activeTab = tab.id;

    this.activeTabChange.emit(this.activeTab);
  }

  isActive(tab: ConfigPanelTab): boolean {
    return this.activeTab === tab.id;
  }
}